import { render } from "./AppEmptyState.vue?vue&type=template&id=c1a3e904&scoped=true"
const script = {}

import "./AppEmptyState.vue?vue&type=style&index=0&id=c1a3e904&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a3e904"]])

export default __exports__